import { 
  ATTRIBUTES_FETCH, 
  ATTRIBUTES_CATEGORIES_FETCH,
  LANGUAGES_FETCH,
  ATTRIBUTES_MODEL_FETCH,
  ATTRIBUTES_ARCHIVE,
  RESTAURANT_ATTRIBUTE_UPDATE,
} from "../action-types/attributes-types";

const initialState = {
  entities: [],
  entity: {},
  attributeList:{},
  entityLoaded: false,
  loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ATTRIBUTES_FETCH.REQUEST:
    case ATTRIBUTES_ARCHIVE.REQUEST:
    case ATTRIBUTES_CATEGORIES_FETCH.REQUEST:
    case LANGUAGES_FETCH.REQUEST:
    case RESTAURANT_ATTRIBUTE_UPDATE.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ATTRIBUTES_CATEGORIES_FETCH.REJECTED:
    case LANGUAGES_FETCH.REJECTED:
    case ATTRIBUTES_FETCH.REJECTED:
    case RESTAURANT_ATTRIBUTE_UPDATE.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case ATTRIBUTES_FETCH.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data],
        loading: false,
      };
    case ATTRIBUTES_CATEGORIES_FETCH.SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
        loading: false,
      }
    case LANGUAGES_FETCH.SUCCESS:
      return {
        ...state,
        languages:action.payload.data,
        loading: false,
      }
    case ATTRIBUTES_ARCHIVE.SUCCESS:
    case RESTAURANT_ATTRIBUTE_UPDATE.SUCCESS:
      return {
        ...state,
        updated:{...action.payload.data},
        loading: false,
      }    
    case ATTRIBUTES_MODEL_FETCH.SUCCESS:
      return {
        ...state,
        attributeList:{
          paginationConfig: {
            ...action.payload.data.result.pagination
          },
          data: action.payload.data.result.models
        }
      }
    default:
      return state;
  }
}
